// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"yP-z","carouselContainer":"zP-z"};